enum NegotiationPortalFlowTypeEnum {
  SegundaViaBoleto = 'SVB',
  Quitacao = 'Q',
  Renegociacao = 'R',
}

export default NegotiationPortalFlowTypeEnum
